import _ from 'lodash';
import {
    FETCH_RAINPRO_SELLERS,
    CLEAN_RAINPRO_SELLERS,
    CHANGE_RAINPRO_SELLER_EMAIL,
    CHANGE_RAINPRO_SELLER_SETTINGS,
} from './types';
import { request, __ } from '../functions';

export const fetchRainproSellers = (screen, options = {}) => {
    const defaults = {
        page: 1,
        per_page: 0,
        filtered: {},
    };

    options = { ...defaults, ...options };

    let params = { page: options.page, per_page: options.per_page };

    // Nasetujeme filter
    _.forEach(options.filtered, (value, key) => {
        params = { ...params, ...{ [`filter_${key}`]: value } };
    });

    return dispatch => request('/rainpro/sellers', params).then(response => {
        const { data, sync } = response.data;
        const { setUser } = screen.props;

        // Nasetujeme user data
        setUser(sync.user);

        dispatch({ type: FETCH_RAINPRO_SELLERS, payload: data });
    });
};

export const changeRainproSellerEmail = (screen, id, email) => {
    const settings = {
        email_new: email,
    };

    return dispatch => request(`/rainpro/changeUserSettings/${id}`, { settings }, 'POST').then(response => {
        const { status } = response.data;

        if (status === 'error') {
            screen.showSnackbar('error', __('Nepodarilo sa zmeniť email'));
            return;
        }

        screen.showSnackbar('success', __('Email bol zmenený'));

        dispatch({ type: CHANGE_RAINPRO_SELLER_EMAIL, payload: { id, email } });
    });
};

export const changeRainproSellerPassword = (screen, id, password, password_repeat) => {
    const settings = {
        password_new: password,
        password_new_repeat: password_repeat,
    };

    return dispatch => request(`/rainpro/changeUserSettings/${id}`, { settings }, 'POST').then(response => {
        const { status } = response.data;

        if (status === 'error') {
            screen.showSnackbar('error', __('Nepodarilo sa zmeniť heslo'));
            return;
        }

        screen.showSnackbar('success', __('Heslo bolo zmenené'));
    });
};

export const changeRainproSellerSettings = (screen, id, settings, type = 'settings', reducerSettings = null) => {
    return dispatch => request(`/rainpro/setSellerSettings/${id}`, { settings }, 'POST').then(response => {
        const { status } = response.data;

        if (status === 'error') {
            screen.onChangeSettings('loading', false);
            screen.showSnackbar('error', __('Nepodarilo sa uložiť nastavenia'));
            return;
        }

        screen.closeLightbox('settings');
        screen.showSnackbar('success', __('Nastavenia boli uložené'));

        if (reducerSettings !== null) {
            dispatch({ type: CHANGE_RAINPRO_SELLER_SETTINGS, payload: { id, settings: reducerSettings } });
            return;
        }

        dispatch({ type: CHANGE_RAINPRO_SELLER_SETTINGS, payload: { id, settings } });
    });
};

export const cleanRainproSellers = () => ({ type: CLEAN_RAINPRO_SELLERS });
